/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { SocialActions, CATEGORY, LINE_OF_BUSINESS } from './Social.meta';
import { SCREEN_NAME } from '../constants';

export { SCREEN_NAME };

export type SocialTapParams = {
  payload: {
    params: {
      label: string;
    };
  };
};

const buildSocialTapEvent = (category: string, label: string) => ({
  label,
  screenName: SCREEN_NAME.homeV2,
  screen_name: SCREEN_NAME.homeV2,
  category,
  lineofbusiness: LINE_OF_BUSINESS.socialUgc,
});

export default {
  [SocialActions.Header_Tap]: ({ payload: { params } }: SocialTapParams) =>
    buildSocialTapEvent(CATEGORY.home_arrow, params.label),

  [SocialActions.Footer_Chip_Tap]: ({ payload: { params } }: SocialTapParams) =>
    buildSocialTapEvent(CATEGORY.home_chip, params.label),
};
